import * as React from 'react'
import { Box, List, ListItem } from "@mui/material"
import { formatPrice, formatProductsUnits } from "@ui-seeker/utils"

import { NotAllowedBlock } from '@components'
import { catalogueAnalyzerRowClick } from '../../@signals'
import { COLOR_KEYS } from '../@constants'



export default function groupedColumn(key, toogleSelected, isPriceSelected) {
	const keyRow = `${key}${toogleSelected}`
	
	return {
		name: keyRow, label: key,
		options: {
			filter: false,
			customBodyRowRender: (value, { subRows, ...dataRow }, { rowIndex }) => {
				const isClicked = rowIndex === catalogueAnalyzerRowClick.value
				return <Box sx={{ textAlign: 'center' }}>
					<Box sx={{ backgroundColor: COLOR_KEYS[value?.color], p: 1, borderRadius: 1, mx: 2 }}>
						{ !!isPriceSelected && formatPrice(value?.value, dataRow[`${key}Currency`])}
						{ !isPriceSelected && !!value?.value && formatProductsUnits(value?.value)}
						{ !isPriceSelected && !value?.value && <NotAllowedBlock />}
					</Box>
					{ !!isClicked  && <List sx={{ ml: 1 }}>
                        {subRows.map((dataSub, idx) => <ListItem key={idx} sx={{ justifyContent: 'center' }}>
                            { !!isPriceSelected && formatPrice(dataSub[keyRow], dataRow[`${key}Currency`])}
							{ !isPriceSelected && !!dataSub[keyRow] && formatProductsUnits(dataSub[keyRow])}
							{ !isPriceSelected && !dataSub[keyRow] && <NotAllowedBlock />}
                        </ListItem>)}
                    </List> }
				</Box>
			}
		}
	}
}